import 'modaal';

function initModaal(trigger) {
      trigger = $(trigger)
    
      trigger.modaal({
        type: 'image',
        background: '#58595B',
        overlay_opacity: 0.9,
    });
}

export default {
    initModal : initModaal
}